export interface PhoneCountry {
  code: string;
  label: string;
  dialCode: string;
  flag: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
  { code: "PH", label: "Philippines", dialCode: "+63", flag: "🇵🇭" },
  { code: "SG", label: "Singapore", dialCode: "+65", flag: "🇸🇬" },
  { code: "US", label: "United States", dialCode: "+1", flag: "🇺🇸" },
  { code: "CA", label: "Canada", dialCode: "+1", flag: "🇨🇦" },
  { code: "AU", label: "Australia", dialCode: "+61", flag: "🇦🇺" }
];

export const DEFAULT_PHONE_COUNTRY = "PH";

export function getCountryByCode(code: string): PhoneCountry {
  const upper = code.toUpperCase();
  return (
    PHONE_COUNTRIES.find((country) => country.code === upper) ??
    PHONE_COUNTRIES.find((country) => country.code === DEFAULT_PHONE_COUNTRY) ??
    PHONE_COUNTRIES[0]
  );
}

export function resolvePhoneCountry(value: string, fallbackCode = DEFAULT_PHONE_COUNTRY) {
  const trimmed = (value ?? "").trim();
  const match = PHONE_COUNTRIES.find((country) =>
    trimmed.startsWith(country.dialCode)
  );
  const country = match ?? getCountryByCode(fallbackCode);
  const stripped = match
    ? trimmed.slice(match.dialCode.length)
    : trimmed.startsWith("+")
    ? trimmed.slice(1)
    : trimmed;
  const localDigits = stripped.replace(/[^0-9]/g, "");
  return { country, localDigits };
}

export function buildE164(country: PhoneCountry, localDigits: string): string {
  const digitsOnly = localDigits.replace(/[^0-9]/g, "");
  if (!digitsOnly) {
    return "";
  }
  return `${country.dialCode}${digitsOnly}`;
}
